module.exports = {"370772004":"央子街道","370772005":"大家洼街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370772.json
// module id = 1536
// module chunks = 0